import { BasePacket } from './basePacket';

export class HeartRatePacket extends BasePacket {
  public heartRate: number = 0;
  public beats: number = 0;
  public beatTime: number = 0;

  constructor(data: any) {
    super(data);
    this.readHeartRate(data);
  }

  private readHeartRate(data: any) {
    const antBuffer = data.slice(17);
    if (antBuffer.length < 4) {
      return;
    }
    this.heartRate = antBuffer.readUInt8(3);
    this.beats = antBuffer.readUInt8(2);
    this.beatTime = antBuffer.readUInt16LE(0);
  }
}
